import { useEffect } from 'react'
import { useSessionStorage } from 'usehooks-ts'

const COUNTRY_RESTRICTED = ['ae', 'ir', 'cr', 'us', 'pl', 'cy', 'th']

let promiseFetch: Promise<any> | null = null
export const useGeoLocation = () => {
  const [country, setCountry] = useSessionStorage<string | undefined>('country', undefined)

  useEffect(() => {
    if (!promiseFetch) {
      promiseFetch = fetch('/api/geo')
        .then((res) => res.json(), () => {
          promiseFetch = null;
        })
        .then((data) => {
          setCountry(data.country)
        }).catch(() => {
          promiseFetch = null;
        })
    }
  }, [])

  return { country, restricted: COUNTRY_RESTRICTED.includes(country || '') }
}
